module.exports = __webpack_public_path__ + "static/img/WHR.46cc0e5b.svg";